export default "__VITE_ASSET__afb1fcec__"